import { CHATBOT_API_URL, CHATBOT_CUSTOMER } from './constants'

import { WindowWithChatbot } from './type'

declare const window: WindowWithChatbot

const initChatbot = (token: string | null = null) => {
    if (!window.chatwidget?.init || !CHATBOT_CUSTOMER) return

    window.chatwidget.init({
        apiUrl: CHATBOT_API_URL ?? '',
        customer: CHATBOT_CUSTOMER,
        token,
    })
}

export const ChatbotWidget = {
    init: initChatbot,
}
